<template>
  <div class="gx-cw">
    <top-banner
        :nav-items="navItems"
        :unread="unreadCount"
        @bell="goNotification"
        @legacy="goLegacy"
        @logo="goHome"
        @logout="logout"
        @nav="onNav"
    />

    <div class="gx-layout">
      <!-- 侧栏（新版 wb-cloud 菜单） -->
      <aside :style="{ width: collapsed ? '48px' : '210px' }" class="gx-cw__sidebar">
        <button class="gx-cw__collapse" @click="collapsed = !collapsed">
          <span :style="{ transform: collapsed ? 'rotate(180deg)' : 'none' }">◀</span>
        </button>

        <!--        <nav class="gx-cw__nav">
                  <button
                    v-for="item in newUiVisibleItems('cloud', menu)"
                    :key="item.id"
                    class="gx-cw__item"
                    :class="{ 'gx-cw__item&#45;&#45;on': activeId === item.id }"
                    :title="collapsed ? item.label : undefined"
                    @click="go(item)"
                  >
                    <span class="gx-cw__item-icon">{{ item.icon }}</span>
                    <span v-if="!collapsed" class="gx-cw__item-label">{{ item.label }}</span>
                  </button>
                </nav>-->
        <nav class="gx-cw__nav">
          <template v-for="item in newUiVisibleItems('cloud', menu)">
            <div v-if="item.children" :key="item.id" class="gx-cw__group">
              <button :class="{ 'gx-cw__item--on':activeParentId === item.id }" :title="collapsed ? item.label : undefined"
                      class="gx-cw__item gx-cw__item-parent" @click="toggleGroup(item.id)">
                <span class="gx-cw__item-icon">{{ item.icon }}</span>
                <span v-if="!collapsed" class="gx-cw__group-label">{{ item.label }}</span>
                <span>
                  <svg :style="`flex-shrink: 0; transition: transform 0.22s cubic-bezier(0.4, 0, 0.2, 1); transform: rotate(${openGroups[item.id]?180:0}deg); opacity: 0.7;`" fill="none" height="10" viewBox="0 0 10 10"
                       width="10"><path
                      d="M2 3.5l3 3 3-3" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="1.4"></path></svg>
                </span>
              </button>
              <div v-if="openGroups[item.id] && !collapsed" class="gx-cw__group-children">
                <button
                    v-for="child in item.children"
                    :key="child.id"
                    :class="{ 'gx-cw__item--on': activeId === child.id }"
                    :title="collapsed ? child.label : undefined"
                    class="gx-cw__item gx-cw__item-child"
                    @click="go(child,item.id)"
                >
                  <span class="gx-cw__item-icon">{{ child.icon }}</span>
                  <span v-if="!collapsed" class="gx-cw__item-label">{{ child.label }}</span>
                </button>
              </div>
            </div>
            <!-- 单独共享菜单 -->
            <button
                v-else
                :key="item.id"
                :class="{ 'gx-cw__item--on': activeId === item.id }"
                :title="collapsed ? item.label : undefined"
                class="gx-cw__item"
                @click="go(item)"
            >
              <span class="gx-cw__item-icon">{{ item.icon }}</span>
              <span v-if="!collapsed" class="gx-cw__item-label">{{ item.label }}</span>
            </button>
          </template>
        </nav>
      </aside>

      <!-- 内容区 -->
      <main id="gx-main" class="gx-main">
        <!-- 云商品库 -->
        <new-cloud-lib-page v-if="activeId === 'cloud'"/>

        <!-- 云品AI优化 -->
        <new-cloud-optimize-page v-else-if="['ai-title','ai-white','ai-34','ai-video'].includes(activeId)" :active-tab="optimizeTabMap[activeId]"/>

        <!-- 标题检测、AI图片检测、星人鉴图 -->
        <new-cloud-check-page v-else-if="['check-keyword','check-img','check-title'].includes(activeId)" :active-tab="checkTabMap[activeId]"/>

        <!-- 云品修改 -->
        <new-batch-modify-page v-else-if="activeId === 'batch-modify'"/>

        <!-- 上架策略 -->
        <new-shelf-strategy-page v-else-if="activeId === 'shelf'"/>

        <!-- 资源盲盒 -->
        <new-blind-box-page v-else-if="activeId === 'blind'"/>
        <!-- SKU检测 -->
        <new-check-sku-page v-else-if="activeId === 'checksku'"/>

        <!-- 云品AI主图 -->
        <new-main-image-page v-else-if="activeId === 'ai-main-image'"/>
        <!-- 云品AI商品套图 -->
        <new-product-image-page v-else-if="activeId === 'ai-product-image'"/>
      </main>
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import TopBanner from '../../components/newUi/TopBanner.vue'
import NewCloudLibPage from '../cloudLib/index.vue'
import NewCloudOptimizePage from '../cloudOptimize/index.vue'
import NewCloudCheckPage from '../cloudCheck/index.vue'
import NewShelfStrategyPage from '../shelfStrategy/index.vue'
import NewBlindBoxPage from '../blindBox/index.vue'
import NewCheckSkuPage from '../checkSku/index.vue'
import NewBatchModifyPage from '../cloudGoodsBatchEdit/BatchModifyPage.vue'
import newUiPermissionMixin from '../../mixins/newUiPermission'
import NewMainImagePage from '../cloudOptimize/mainImage.vue'
import NewProductImagePage from '../cloudOptimize/productSet.vue'

export default {
  name: 'NewCloudWorkbenchPage',
  mixins: [newUiPermissionMixin],
  components: {
    TopBanner,
    NewCloudLibPage,
    NewCloudOptimizePage,
    NewCloudCheckPage,
    NewShelfStrategyPage,
    NewBlindBoxPage,
    NewCheckSkuPage,
    NewMainImagePage,
    NewProductImagePage,
    NewBatchModifyPage
  },
  data() {
    return {
      navItems: [
        {id: null, label: '星人工作台'},
        // {id: 'agent', label: 'Agent工作台'},
        {id: 'shop', label: '店铺工作台'},
        {id: 'finance', label: '财务工作台'},
        {id: 'ops', label: '运营工作台'},
        // {id: 'select', label: '选品工作台'},
        {id: 'cloud', label: '云库工作台', active: true},
        {id: 'presales', label: '售前工作台'},
        {id: 'aftersales', label: '售后工作台'},
        {id: 'system', label: '系统工作台'}
      ],
      // 新版 wb-cloud 菜单（对照 ShopAdminPage.tsx WB_L2_DEFS["wb-cloud"] 与 ICONS）
      menu: [
        {id: 'cloud', label: '云商品库', icon: '☁️', legacy: '/uc_product'},
        {
          id: 'detect', label: '云品AI检测', icon: '🔍',
          children: [
            {id: 'check-keyword', label: '标题检测', icon: '🔤', legacy: '/uc_check'},
            {id: 'checksku', label: 'SKU检测', icon: '💰', legacy: '/uc_checkSku'},
            {id: 'check-img', label: 'AI图片检测', icon: '🖼️', legacy: '/uc_check'},
            // {id: 'check-title', label: '星人鉴图', icon: '✍️', legacy: '/uc_check'}
            {id: 'ai-title', label: 'AI生成标题', icon: '✍️', legacy: '/uc_optimization'},
          ]
        },
        {
          id: 'goods-opt', label: '云品AI优化', icon: '✨',
          children: [
            {id: 'ai-title', label: 'AI标题（去品牌化）', icon: '✍️', legacy: '/uc_optimization'},
            // {id: 'ai-main-image', label: 'AI主图', icon: '🖼️', legacy: '/uc_optimization'},
            // {id: 'ai-product-image', label: 'AI商品套图', icon: '🗂️', legacy: '/uc_optimization'},
            {id: 'ai-white', label: 'AI白底图', icon: '⬜', legacy: '/uc_optimization'},
            {id: 'ai-34', label: 'AI3/4图', icon: '📐', legacy: '/uc_optimization'},
            {id: 'ai-video', label: 'AI视频', icon: '🎬', legacy: '/uc_optimization'},
          ]
        },
        {id: 'batch-modify', label: '云品批量修改', icon: '📦', legacy: '/batch-modify'},
        {id: 'shelf', label: '商品上架策略', icon: '📋', legacy: '/uc_shangjia'},
        {id: 'blind', label: '商品资源盲盒', icon: '🎁', legacy: '/uc_blindBox'},
        // {id: 'checksku', label: '低价引流', icon: '💰', legacy: '/uc_checkSku'}
      ],
      collapsed: false,
      activeId: 'cloud',
      openGroups: {'detect': true, 'goods-opt': true},
      activeParentId: ''
    }
  },
  computed: {
    unreadCount() {
      const notifs = this.$store.state.notification.notifications || []
      return notifs.filter((n) => !n.isRead).length
    },
    optimizeTabMap() {
      return {
        'ai-title': 0,
        'ai-white': 1,
        'ai-34': 2,
        'ai-video': 3
      }
    },
    checkTabMap() {
      return {
        'check-keyword': 0,
        'check-img': 1
      }
    }
  },
  created() {
    const t = this.$route.query.menu
    // if (t && this.menu.some((m) => m.id === t)) this.activeId = t
    if (t && this.findItem(t)) this.activeId = t
    this.$store.dispatch('notification/initNotificationWS')
  },
  methods: {
    ...mapMutations({
      OUT_LOGIN: 'login/OUT_LOGIN'
    }),
    findItem(id) {
      for (const item of this.menu) {
        if (item.id === id) return item
        if (item.children) {
          const found = item.children.find((c) => c.id === id)
          if (found) {
            this.activeParentId = item.id || ''
            return found
          }
        }
      }
      return null
    },
    toggleGroup(id) {
      this.$set(this.openGroups, id, !this.openGroups[id])
    },
    go(item, pid) {
      this.activeId = item.id
      this.activeParentId = pid || ''
      if (this.$route.path !== '/new_cloud_workbench' || this.$route.query.menu !== item.id) {
        this.$router.replace({path: '/new_cloud_workbench', query: {menu: item.id}}).catch(() => {
        })
      }
    },
    goLegacy() {
      this.$router.push('/ucenter_legacy')
    },
    onNav(id) {
      if (id === null) {
        this.$router.push('/ucenter')
        return
      }
      const map = {
        agent: '/new_uc_shop_manage',
        shop: '/new_uc_shop_manage',
        finance: '/new_finance_workbench',
        ops: '/new_ops_workbench',
        select: '/new_select_workbench',
        cloud: '/new_cloud_workbench',
        goods: '/new_goods_workbench',
        presales: '/new_presales_workbench',
        aftersales: '/new_aftersales_workbench',
        system: '/new_system_workbench'
      }
      const route = map[id]
      if (!route) {
        this.$message({message: '该工作台功能开发中，敬请期待', type: 'warning'})
        return
      }
      this.$router.push(route)
    },
    goHome() {
      this.$router.push('/')
    },
    goNotification() {
      this.$router.push('/notification')
    },
    logout() {
      this.OUT_LOGIN()
      this.$message({message: '已退出登录', type: 'success'})
      location.href = '/'
    }
  }
}
</script>

<style scoped>
.gx-cw {
  min-height: 100vh;
  background: #F4F6F8;
  font-family: 'Noto Sans SC', sans-serif;
}

.gx-cw__sidebar {
  flex-shrink: 0;
  background: #EEF1F6;
  border-right: 1px solid #DDE2EC;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  scrollbar-width: none;
  position: relative;
  transition: width .25s cubic-bezier(.4, 0, .2, 1);
}

.gx-cw__sidebar::-webkit-scrollbar {
  display: none;
}

.gx-cw__collapse {
  position: absolute;
  top: 10px;
  right: -12px;
  z-index: 20;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid rgba(212, 169, 70, .3);
  background: #EEF1F6;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .25s;
}

.gx-cw__collapse:hover {
  background: #1a2040;
  border-color: #D4A946;
}

.gx-cw__collapse span {
  font-size: 10px;
  color: #A0AEC0;
  display: inline-block;
  transition: transform .25s;
}

.gx-cw__nav {
  flex: 1;
  padding: 8px 0;
  overflow-y: auto;
  scrollbar-width: none;
}

.gx-cw__group {
  margin-bottom: 4px;
}

.gx-cw__group-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: auto;
}

.gx-cw__group-children {
  padding: 2px 0;
}

.gx-cw__item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 9px 14px;
  border: none;
  border-left: 3px solid transparent;
  background: transparent;
  cursor: pointer;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  color: #5C6B73;
  text-align: left;
  transition: all .18s ease;
}

.gx-cw__item:hover {
  background: rgba(255, 255, 255, .72);
  color: #1A1A2E;
}

.gx-cw__item--on {
  background: #FFFFFF;
  border-left-color: #fa5757;
  color: #1A1A2E;
  font-weight: 600;
}

.gx-cw__item-icon {
  font-size: 15px;
  flex-shrink: 0;
}

.gx-cw__item-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gx-cw__item-parent.gx-cw__item--on {
  background: rgba(255, 255, 255, 0.6);
}

.gx-cw__item-child {
  gap: 8px;
  padding: 6px 14px 6px 26px;
}

.gx-cw__item-child .gx-cw__item-icon {
  font-size: 13px;
  opacity: 0.65;
}

.gx-cw__item-child .gx-cw__item-label {
  font-size: 12px;
}
.gx-cw__item--on .gx-cw__item-icon{
  opacity: 1;
}

</style>
